<template>
  <div>
    <h5>{{ company.Name }}</h5>

    <dl class="company-details">
      <dt>{{ i18n.t('/LeaseCompany/Details/Address') }}</dt>
      <dd>{{ company.Address || '-' }}</dd>
      <dt>{{ i18n.t('/LeaseCompany/Details/Zipcode') }}</dt>
      <dd>{{ company.ZipCode || '-' }}</dd>
      <dt>{{ i18n.t('/LeaseCompany/Details/City') }}</dt>
      <dd>{{ company.City || '-' }}</dd>
      <dt>{{ i18n.t('/LeaseCompany/Details/Email') }}</dt>
      <dd>{{ company.Email || '-' }}</dd>
      <dt>{{ i18n.t('/LeaseCompany/Details/DebtorId') }}</dt>
      <dd>{{ company.DebtorId || '-' }}</dd>
      <dt>{{ i18n.t('/LeaseCompany/Details/CrmNumber') }}</dt>
      <dd>{{ company.CrmNumber || '-' }}</dd>
      <dt>{{ i18n.t('/LeaseCompany/Details/CustomerId') }}</dt>
      <dd>{{ company.CustomerId || '-' }}</dd>
    </dl>
  </div>
</template>

<script>
export default {
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
}
</script>

<style lang="scss" scoped>
h5 {
  display: inline-block;
}

.company-details {
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin-bottom: 1em;
}
</style>
